<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="grid" style="max-width:1580px;margin:0 auto;">
  <div class="col">
    <p-tabView [(activeIndex)]="tabIndex">
      <p-tabPanel header="OTA Status">
        <div>
          <app-ru-properties-status-list></app-ru-properties-status-list>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Properties">
        <div class="grid">
          <span class="col">
            <h2 class="mt-5">Properties</h2>
          </span>

          <span class=" col flex justify-content-end align-items-center mt-4 gap-2">
            <span class="p-float-label ml-3">
              <p-dropdown [options]="shortTermRentalSummaryList" (onChange)="onPropertySelect($event)" [(ngModel)]="selectedShortTermRentalSummary" optionLabel="propertyCode" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="titles">Select Property</label>
            </span>
            <span class="p-float-label ruaccount-dropdown" style="width: 180px;">
              <p-dropdown [options]="ruAccounts" [(ngModel)]="ruAccount" (onChange)="onRUAccount($event)"
                optionLabel="name" optionValue="value" [filter]="false"
                [showClear]="false" placeholder="Select RU Account">
              </p-dropdown>
              <label for="ruAccount">Select RU Account</label>
            </span>
          </span>
        </div>
        <div class="p-4">
          <app-ru-property [ruAccount]="ruAccount"></app-ru-property>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Reservations">
        <div class="grid">
          <span class="col">
            <h2 class="mt-5">Reservations</h2>
          </span>

          <span class=" col flex justify-content-end align-items-center mt-4 gap-2">
            <!--<button pButton type="button" icon="pi pi-plus" label="Create Reservation" class="p-button-text" [routerLink]="['/homeowner-reservation']"></button>-->
            <span class="p-float-label ml-3">
              <p-dropdown [options]="shortTermRentalSummaryList" (onChange)="onPropertySelect($event)" [(ngModel)]="selectedShortTermRentalSummary" optionLabel="propertyCode" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="titles">Select Property</label>
            </span>
            <span class="p-float-label ruaccount-dropdown">
              <p-dropdown [options]="ruAccounts" [(ngModel)]="ruAccount" (onChange)="onRUAccount($event)"
                optionLabel="name" optionValue="value" [filter]="false"
                [showClear]="false" placeholder="Select RU Account">
              </p-dropdown>
              <label for="ruAccount">Select RU Account</label>
            </span>
          </span>
        </div>

        <div class="p-4">
          <app-ru-reservation [ruAccount]="ruAccount"></app-ru-reservation>
        </div>
      </p-tabPanel>


      <p-tabPanel header="Availability">
        <div class="grid">
          <span class="col">
            <h2 class="mt-5">Availability</h2>
          </span>

          <span class=" col flex justify-content-end align-items-center mt-4 gap-2">
            <button pButton type="button" icon="pi pi-plus" label="Create Reservation" class="p-button-text" [routerLink]="['/homeowner-reservation']"></button>
            <span class="p-float-label ml-3">
              <p-dropdown [options]="shortTermRentalSummaryList" (onChange)="onPropertySelect($event)" [(ngModel)]="selectedShortTermRentalSummary" optionLabel="propertyCode" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="titles">Select Property</label>
            </span>
            <span class="p-float-label ruaccount-dropdown">
              <p-dropdown [options]="ruAccounts" [(ngModel)]="ruAccount" (onChange)="onRUAccount($event)"
                optionLabel="name" optionValue="value" [filter]="false"
                [showClear]="false" placeholder="Select RU Account">
              </p-dropdown>
              <label for="ruAccount">Select RU Account</label>
            </span>
          </span>
        </div>

        <div class="p-4">
          <app-ru-availability [ruAccount]="ruAccount"></app-ru-availability>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Rates">
        <div class="grid">
          <span class="col">
            <h2 class="mt-5">Rates</h2>
          </span>

          <span class=" col flex justify-content-end align-items-center mt-4 gap-2">
            <button pButton type="button" icon="pi pi-plus" label="Create Reservation" class="p-button-text" [routerLink]="['/homeowner-reservation']"></button>
            <span class="p-float-label ml-3">
              <p-dropdown [options]="shortTermRentalSummaryList" (onChange)="onPropertySelect($event)" [(ngModel)]="selectedShortTermRentalSummary" optionLabel="propertyCode" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="titles">Select Property</label>
            </span>
            <span class="p-float-label ruaccount-dropdown">
              <p-dropdown [options]="ruAccounts" [(ngModel)]="ruAccount" (onChange)="onRUAccount($event)"
                optionLabel="name" optionValue="value" [filter]="false"
                [showClear]="false" placeholder="Select RU Account">
              </p-dropdown>
              <label for="ruAccount">Select RU Account</label>
            </span>
          </span>
        </div>

        <div class="p-4">
          <app-ru-prices [ruAccount]="ruAccount"></app-ru-prices>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Buildings">
        <div class="grid">
          <span class="col">
            <h2 class="mt-5">Buildings</h2>
          </span>

          <span class=" col flex justify-content-end align-items-center mt-4">
            <button pButton type="button" icon="pi pi-plus" label="Create Reservation" class="p-button-text" [routerLink]="['/homeowner-reservation']"></button>
            <span class="p-float-label ml-3">
              <p-dropdown [options]="shortTermRentalSummaryList" (onChange)="onPropertySelect($event)" [(ngModel)]="selectedShortTermRentalSummary" optionLabel="propertyCode" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="titles">Select Property</label>
            </span>
          </span>
        </div>

        <div class="p-4">
          <app-ru-building></app-ru-building>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Settings">
        <div class="grid">
          <span class="col">
            <h2 class="mt-5">Property Settings</h2>
          </span>

          <span class=" col flex justify-content-end align-items-center mt-4">
            <span class="p-float-label ml-3">
              <p-dropdown [options]="shortTermRentalSummaryList" (onChange)="onPropertySelect($event)" [(ngModel)]="selectedShortTermRentalSummary" optionLabel="propertyCode" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="titles">Select Property</label>
            </span>
          </span>
        </div>

      </p-tabPanel>

      <!-- ===== QUALITY CHECK TAB (Hotel Room V2) ===== -->
      <p-tabPanel header="Quality Check">
        <div class="grid">
          <span class="col">
            <h2 class="mt-5">WIKI vs RU Quality Check</h2>
            <p class="text-600 text-sm mt-1">
              Compare internal (WIKI) availability and LOS pricing against live Rentals United data
              for any property — especially Hotel Room (type 3) virtual listings.
            </p>
          </span>
          <span class="col flex justify-content-end align-items-center mt-4 gap-2">
            <span class="p-float-label ruaccount-dropdown" style="width: 180px;">
              <p-dropdown [options]="ruAccounts" [(ngModel)]="ruAccount" (onChange)="onRUAccount($event)"
                optionLabel="name" optionValue="value" [filter]="false"
                [showClear]="false" placeholder="Select RU Account">
              </p-dropdown>
              <label>Select RU Account</label>
            </span>
          </span>
        </div>
        <div class="p-4">
          <app-ru-quality-check [ruAccount]="ruAccount"></app-ru-quality-check>
        </div>
      </p-tabPanel>

      <p-tabPanel header="OTA Tools" *ngIf="canRunSyncAll">
        <div class="grid">
          <span class="col">
            <h2 class="mt-5">OTA Tools</h2>
          </span>
        </div>

        <div class="p-4">
          <p-card header="Sync All Properties" styleClass="mb-4">
            <p>Triggers a full channel status sync for all properties across all OTA channels (VRBO, Airbnb, Expedia, etc.). This operation may take 30–90 seconds to complete.</p>

            <div class="flex align-items-center gap-3 mt-3">
              <button pButton type="button" icon="pi pi-refresh" label="Run OTA Sync-All"
                class="p-button-warning"
                [disabled]="syncAllLoading"
                (click)="confirmSyncAll()">
              </button>
              @if (syncAllLoading) {
                <span class="flex align-items-center gap-2">
                  <p-progressSpinner [style]="{'width':'28px','height':'28px'}" strokeWidth="4"></p-progressSpinner>
                  <span class="text-500">Syncing — this may take up to 90 seconds...</span>
                </span>
              }
            </div>

            @if (syncAllResult) {
              <div class="mt-4 p-3 border-round surface-100">
                <h4 class="mt-0 mb-2"><i class="pi pi-check-circle text-green-500 mr-2"></i>Sync Completed</h4>
                <pre style="white-space: pre-wrap; word-break: break-all; font-size: 0.85rem;">{{ syncAllResult | json }}</pre>
              </div>
            }

            @if (syncAllError) {
              <div class="mt-4 p-3 border-round surface-100">
                <h4 class="mt-0 mb-2 text-red-500"><i class="pi pi-times-circle mr-2"></i>Sync Failed</h4>
                <p class="text-red-500">{{ syncAllError }}</p>
              </div>
            }
          </p-card>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<h2>Links</h2>

<table>
  <tr>
    <td>Developer API</td>
    <td><a href="https://developer.rentalsunited.com/?xml#api-reference" target="_blank" rel="noopener">https://developer.rentalsunited.com/?xml#api-reference</a></td>
  </tr>
</table>
